import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { deriveTitleFromPath } from '@src/components/sco/utilities/SEOMetadata/seo-utils';
import { BreadcrumbSEO } from '@src/components/sco/utilities/SEOProvider/BreadcrumbSEO';
import { ContentItemSEO } from '@src/components/sco/utilities/SEOProvider/ContentItemSEO';
import { SiteSectionSEO } from '@src/components/sco/utilities/SEOProvider/SiteSectionSEO';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { startupsUrl } from '@src/lib/startups-url';
import { seoDefaults } from '@src/seo-defaults';
import { usePathname } from 'next/navigation';
import React from 'react';
export const SEOProvider = () => {
  const $ = _c(24);
  const activeContent = useActiveContentContext();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = startupsUrl("/api/og-image", {
      title: deriveTitleFromPath(pathname)
    });
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== pathname) {
    t1 = deriveTitleFromPath(pathname);
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== pathname) {
    t2 = startupsUrl(pathname);
    $[4] = pathname;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    const seoProps = {
      ...seoDefaults,
      imageUrl: t0,
      title: t1,
      url: t2
    };
    t3 = <SEOMetadata {...seoProps} />;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== activeContent.siteSection) {
    t4 = activeContent.siteSection && <SiteSectionSEO siteSection={activeContent.siteSection} />;
    $[10] = activeContent.siteSection;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== activeContent.breadcrumbs) {
    t5 = activeContent.breadcrumbs?.length > 0 && <BreadcrumbSEO breadcrumbs={activeContent.breadcrumbs} />;
    $[12] = activeContent.breadcrumbs;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== activeContent.item) {
    t6 = activeContent.item && <ContentItemSEO item={activeContent.item} />;
    $[14] = activeContent.item;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== activeContent.seoProps) {
    t7 = activeContent.seoProps && <SEOMetadata {...activeContent.seoProps} />;
    $[16] = activeContent.seoProps;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <>{t3}{t4}{t5}{t6}{t7}</>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};